export default __webpack_public_path__ + "static/media/Belt of the Doomsayer.543b6581.jpg";